import {Component, Inject, Vue} from "vue-property-decorator";
import {MainContainer} from "~/components/main-container";
import {PageTitle} from "~/components/page-title";
import {StatsNavigationTabs, StatsTab} from "~/modules/stats/compponents/navigation-tabs";
import {StatsActions} from "~/modules/stats/compponents/stats-actions";
import {StatsAuth} from "~/modules/stats/compponents/stats-auth";
import {icons} from "~/components/icon";
import {AppSettings} from "~/lib/app-settings";

@Component
export class StatsView extends Vue {

  @Inject() appSettings: AppSettings;
  private currentTab: StatsTab = StatsTab.Auth;

  renderContent() {
    switch (this.currentTab) {
      case StatsTab.Auth :
        return <StatsAuth clientUUID={this.appSettings.clientUUID} />;
      case StatsTab.Actions :
        return <StatsActions clientUUID={this.appSettings.clientUUID} />;
    }
  }

  render() {
    return (
      <MainContainer>
        <PageTitle icon={icons.stats} title="Statistiques"/>
        <StatsNavigationTabs v-model={this.currentTab} />
        <div class="page-content">
          {this.renderContent()}
        </div>
      </MainContainer>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7cb34664/stats-view.tsx" });